import { useQuery } from '@tanstack/react-query';

import { useCapabilitiesOptions } from './use-capabilities-options';

export const SYSTEM_CAPABILITIES_ID = 'arcticwolf';

export function useSystemCapabilities() {
  const options = useCapabilitiesOptions(SYSTEM_CAPABILITIES_ID);

  return useQuery(options);
}
